module.exports = {
	"de": {
		"hqm": {
			"support-button": "Support erhalten",
			"support-page": {
				"create-ticket": {
					"title": "Support erhalten",
					"instructions": "Reichen Sie unten eine Anfrage ein und wir melden uns bei Ihnen.",
					"fields": {
						"mid": {
							"label": "Shop wählen",
							"validation": "Shop ist erforderlich"
						},
						"topic": {
							"question": "Um was geht es bei Ihrer Frage?",
							"label": "Wählen Sie ein Thema aus",
							"validation": "Thema ist erforderlich",
							"options": {
								"orders": "Bestellungen",
								"settlements": "Abrechnungen",
								"agreements": "Vereinbarungen",
								"technical_issues": "Technische Störungen",
								"others": "Sonstige"
							}
						},
						"subject": {
							"label": "Betreff",
							"validation": "Betreff ist erforderlich"
						},
						"description": {
							"label": "Nachricht",
							"validation": "Beschreibung ist erforderlich"
						},
						"attachment": {
							"label": "Anlagen hinzufügen",
							"button": "Hochladen",
							"info": "Das Hinzufügen von Screenshots hilft, das Problem schneller zu lösen.",
							"supportedFileTypes": "Unterstützte Dateiformate: .png, .jpg, .pdf",
							"error": "Die Gesamtgröße der Dateien darf nicht über 15 MB liegen."
						}
					},
					"submit": "Anfrage einreichen",
					"service-unavailable-error": "",
					"generic-error": "",
					"contact-page-link": "Kontaktieren Sie uns"
				},
				"view-ticket": {
					"title": "Fertig!",
					"details": "Wir haben Ihre Anfrage erhalten und werden uns bald bei Ihnen melden. Das sind Ihre Daten:",
					"ticket": "Anfrage Nr. {ticketId}",
					"email": "E-Mail: {email}",
					"status": "Sie können den Status in unserer Support-Seite einsehen",
					"track": "Status einsehen"
				}
			},
			"popup": {
				"yes": "Ja",
				"no": "Nein",
				"somethingElse": "Ich benötige Hilfe zu einem anderen Anliegen"
			},
			"header": {
				"homeLink": "Zurücksetzen"
			},
			"home": {
				"greeting": "Hallo, {givenName}! Wie können wir Ihnen helfen?",
				"topics": "Wobei benötigen Sie Hilfe?"
			},
			"topics": {
				"expandButton": "Mehr"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Es tut uns leid, dass dies nicht weitergeholfen hat. Vielleicht finden Sie in diesen Artikeln eine Lösung?",
				"stillQuestionsTitle": "Noch Fragen?",
				"stillQuestionsParagraph": "Sie können sich auch direkt an uns wenden.",
				"contactButton": "Kontakt"
			},
			"feedback": {
				"title": "Hat Ihnen das weitergeholfen?",
				"optionYes": "Ja, das hat mir weitergeholfen",
				"optionNo": "Nein, ich benötige noch Hilfe",
				"positiveFeedback": "Vielen Dank für das positive Feedback, das macht es für uns viel einfacher, Ihnen in Zukunft relevantere Artikel bieten zu können."
			},
			"freeTextFeedback": {
				"title": "Helfen Sie uns, besser zu werden",
				"placeholder": "Warum fanden Sie diesen Inhalt nicht nützlich?",
				"submitButton": "Absenden",
				"feedbackMessage": "Vielen Dank für Ihr Feedback, das macht es für uns viel einfacher, Ihnen in Zukunft relevantere Artikel bieten zu können."
			},
			"relatedContent": {
				"title": "Relevante Inhalte"
			},
			"search": {
				"buttonLabel": "Suchen",
				"input": "Suche nach Artikeln ...",
				"loading": "Lädt …",
				"results": {
					"contact": "Sie finden nicht die benötigte Hilfe?",
					"empty": "Leider wurden keine Ergebnisse für Ihre Anfrage gefunden. Versuchen Sie, nach einem anderen Begriff zu suchen.",
					"singleTopicFound": "Wir haben 1 Thema gefunden",
					"multipleTopicsFound": "Wir haben {count} Themen gefunden",
					"singleArticleFound": "Wir haben 1 Artikel gefunden",
					"multipleArticlesFound": "Wir haben {count} Artikel gefunden"
				}
			},
			"contact": {
				"title": "Kontakt",
				"channelsIntro": "Wenden Sie sich an uns, sodass wir Ihnen behilflich sein können.",
				"businessDetailsTitle": "Ihre Geschäftsdaten",
				"businessDetailsName": "Name des Geschäfts",
				"businessDetailsEmail": "E-Mail",
				"businessDetailsMid": "Händler ID",
				"phone": {
					"title": "Rufen Sie uns an",
					"paragraph": "Sie können uns werktags während der Geschäftszeiten anrufen. Wenn Sie in Schweden oder im Vereinigten Königreich wohnen, können Sie uns auch am Wochenende zwischen 10:00 und 16:00 Uhr anrufen."
				},
				"chat": {
					"title": "Chatten Sie mit uns",
					"paragraph": "Die schnellste und einfachste Art und Weise, unseren Support zu erreichen. Unser Chat ist derzeit verfügbar.",
					"button": "Chat öffnen"
				},
				"email": {
					"title": "Schreiben Sie uns eine E-Mail",
					"paragraph": "Schreiben Sie uns eine E-Mail. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen."
				}
			},
			"errorBoundary": {
				"title": "Ein Fehler ist aufgetreten",
				"message": "Bedauerlicherweise ist ein Fehler aufgetreten. Sie können auf die Schaltfläche unten klicken, um einen Neustart einzuleiten und diese Seitenleiste zu schließen.",
				"resetButton": "Zurücksetzen",
				"errorId": "Fehler-ID: {errorId}"
			},
			"tour": {
				"prev": "Zurück",
				"next": "Weiter",
				"done": "Fertig"
			},
			"notAvailableMobile": {
				"title": "Nicht verfügbar",
				"buttonBack": "Zurück",
				"paragraph": "Dieser Inhalt ist auf Ihrem Gerät nicht verfügbar. Versuchen Sie, ihn auf einem Gerät mit höherer Bildschirmauflösung zu starten, etwa auf einem Desktop-Computer."
			},
			"shareButton": {
				"title": {
					"article": "Einen Deep-Link zu diesem Artikel teilen",
					"topic": "Einen Deep-Link zu diesem Thema teilen",
					"tour": "Einen Deep-Link zu dieser Tour teilen"
				},
				"radioItemHome": "Start App",
				"descriptionHome": "Öffnet den Hilfe-Artikel auf der Startseite im Händlerportal",
				"radioItemCurrent": "Aktuelle Seite",
				"descriptionCurrent": "Öffnet den Hilfe-Artikel auf der aktuellen Seite"
			}
		},
		"orientation": {
			"title": "Lernen Sie ..."
		},
		"core": {
			"alert": {
				"message": "Ein Fehler ist aufgetreten. Versuchen Sie es bitte erneut.",
				"correlationIdLabel": "Korrelations-ID:"
			},
			"header": {
				"title": "Händlerportal"
			},
			"usermenu": {
				"language": "Sprache",
				"country": "Land",
				"timezone": "Zeitzone",
				"logout": "Abmelden",
				"profile": "Profil",
				"changeProfile": "Bearbeiten",
				"tooltip": "Ihr Profil"
			},
			"appsmenu": {
				"defaultTooltip": "Ihre Apps",
				"initialTooltip": "Finden Sie hier Ihre Apps.",
				"newAppsTooltip": "Wir haben neue Apps für Sie!"
			},
			"helpful-question-mark": {
				"helpLabel": "Hilfe"
			},
			"languages": {
				"da": "Dänisch",
				"de": "Deutsch",
				"en": "German",
				"en_GB": "Englisch (GB)",
				"en_US": "Englisch (US)",
				"es": "Spanisch",
				"fi": "Finnisch",
				"fr": "Französisch",
				"it": "Italienisch",
				"nl": "Niederländisch",
				"no": "Norwegisch",
				"sv": "Schwedisch"
			},
			"countries": {
				"de": "Deutschland",
				"dk": "Dänemark",
				"fi": "Finnland",
				"gb": "Vereinigtes Königreich",
				"nl": "Niederlande",
				"no": "Norwegen",
				"se": "Schweden",
				"us": "USA"
			},
			"selectLanguage": {
				"title": "Wählen Sie Ihre Sprache",
				"paragraph": "Dies ist Ihre Standardsprache.",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Wählen Sie Ihr Land",
				"paragraph": "Dies ist Ihr Standardland.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Details aktualisieren",
				"submit": "OK",
				"emailLabel": "E-Mail-Adresse",
				"firstNameLabel": "Vorname",
				"lastNameLabel": "Nachname",
				"resetPasswordLabel": "Passwort zurücksetzen",
				"resetPasswordSuccessLabel": "E-Mail zum Zurücksetzen des Passworts versandt",
				"resetPasswordErrorLabel": "Fehler beim Senden der E-Mail zum Zurücksetzen des Passworts",
				"error": "Aktualisierung der Details fehlgeschlagen"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle Rechte vorbehalten",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "AGB"
			},
			"accessDenied": {
				"title": "Sie benötigen zusätzliche Berechtigungen für diese Seite.",
				"message": "Bei Fragen wenden Sie sich bitte an Ihren Administrator oder an Klarna."
			},
			"midSelector": {
				"label": "Händler"
			},
			"storeSelector": {
				"label": "Händler"
			},
			"storesSelector": {
				"closeText": "Fertig",
				"closeTextWithSelection": "# Auswahl(en) anwenden",
				"deselectAllOptionText": "Auswahl löschen",
				"emptyStateText": "Keine Händler gefunden.",
				"label": "Händler",
				"searchFieldLabel": "Nach Händler suchen",
				"selectAllOptionText": "Alle Händler auswählen",
				"selectedAllText": "Alle Händler",
				"selectedText": "# Händler"
			},
			"pagination": {
				"ofLabel": "von",
				"noResultsLabel": "Keine Ergebnisse"
			},
			"dateRangePicker": {
				"startLabel": "Startdatum",
				"endLabel": "Enddatum",
				"months": {
					"january": "Januar",
					"february": "Februar",
					"march": "März",
					"april": "April",
					"may": "Mai",
					"june": "Juni",
					"july": "Juli",
					"august": "August",
					"september": "September",
					"october": "Oktober",
					"november": "November",
					"december": "Dezember"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "D",
					"wednesday": "M",
					"thursday": "D",
					"friday": "F",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "NEU"
			},
			"appCategory": {
				"dayToDay": "Für das Tagesgeschäft",
				"nko": "Klarna Online",
				"tools": "Anwendungen",
				"preferences": "Einstellungen"
			},
			"apps": {
				"home-fe": {
					"title": "Start"
				},
				"nko-app": {
					"title": "Klarna Online Apps"
				},
				"orders-fe": {
					"title": "Bestellungen",
					"description": "Suchen und Verwalten Ihrer Bestellungen über Klarna.",
					"nkoLinkText": "Ältere Bestellungen abrufen"
				},
				"nko-orders": {
					"title": "Bestellungen (KO)",
					"description": "Durchsuchen und Verwalten Ihrer Bestellungen über Klarna Online."
				},
				"settlements-fe": {
					"title": "Abrechnungen",
					"description": "Abrechnungs- und Auszahlungsberichte anpassen und herunterladen",
					"nkoLinkText": "Ältere Berichte abrufen"
				},
				"nko-settlements": {
					"title": "Abrechnungen (KO)",
					"description": "Berichte zu Bestellungen und Auszahlungen von Klarna Online finden."
				},
				"logs-app-fe": {
					"title": "Protokolle",
					"description": "API-Protokolle durchsuchen, um Integrationsprobleme zu beheben."
				},
				"users-fe": {
					"title": "Benutzer",
					"description": "Neue Benutzer einladen und bestehende Benutzer im Portal verwalten."
				},
				"settings-fe": {
					"title": "Anmeldedaten verwalten",
					"description": "Ihre Klarna API-Zugangsdaten anfordern und Shop-Einstellungen verwalten."
				},
				"nko-settings": {
					"title": "Einstellungen (KO)",
					"description": "Ihre Shop-Einstellungen, Berichte und Kontaktdaten verwalten."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Neue Bestellungen mit der Klarna In-Store-Lösung erstellen."
				},
				"products-fe": {
					"title": "Produkte",
					"description": "Leitfäden dazu, wie Sie Klarna optimal nutzen können."
				},
				"upstream-fe": {
					"title": "On-site Messaging",
					"description": "Mehr verkaufen mit maßgeschneiderten und personalisierten Finanzierungsangeboten."
				},
				"lending-fe": {
					"title": "Händlerkredit",
					"description": "Unternehmensfinanzierung leicht gemacht."
				},
				"branding-fe": {
					"title": "Branding",
					"description": "Bestimmen Sie, wie Ihre Marke innerhalb von Klarna präsentiert wird."
				},
				"disputes-fe": {
					"title": "Beanstandungen",
					"description": "Beanstandungen bearbeiten."
				},
				"logistics-fe": {
					"title": "Logistik",
					"description": "Verwalten Sie Ihre gesamte Logistik an einem Ort."
				},
				"ob-transactions-fe": {
					"title": "Transaktionen",
					"description": "Offene Banking-Transaktionen"
				},
				"developers": {
					"title": "Entwickler"
				},
				"product-upgrade-fe": {
					"title": "Produkt-Upgrade"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Erhalten Sie hier Marketing-Assets, um Ihr Geschäft auszubauen."
				},
				"business-card-fe": {
					"title": "Visitenkarte",
					"description": "Folgt in Kürze"
				},
				"support": {
					"title": "Support",
					"description": "Ihre Support-Anfragen überprüfen und verwalten"
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Zurück"
				}
			},
			"errorBoundary": {
				"contact": "Aktualisieren Sie die Seite. {br}Wenn der Fehler weiterhin auftritt, wenden Sie sich an den <supportLink>Händler-Support</supportLink> unter Angabe der Fehler-ID {errorId}.",
				"errorDescription": "Fehler-ID - {errorId}",
				"reloadButton": "Aktualisieren",
				"title": "Leider ist ein Fehler aufgetreten"
			},
			"maintenance": {
				"pageTitle": "Wartungsarbeiten",
				"title": "Das Händlerportal befindet sich derzeit in einer geplanten Wartung.",
				"summary": "Wir sind in Kürze wieder da",
				"scheduledSummary": "Um {until} sind wir wieder da"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "Einer der wichtigsten Tage für den Einzelhandel steht bevor. Am Black Friday sind wir für Sie da, um beinahe in Echtzeit Statistiken Ihrer Umsätze zu bieten. Bis dahin können wir uns schon mal auf den Erfolg vorbereiten!",
				"countdown": "Noch #dT #hS #mM #sS…",
				"box1": {
					"title": "3,5 mal mehr Ausgaben*",
					"text": "Im letzten Jahr haben Klarna-Kunden* am Black Friday im Durchschnitt 3,5 mal mehr ausgegeben als an jedem anderen Tag im Jahr.",
					"footnote": "*Durchschnitt aller Händlerkategorien und -regionen bei Klarna."
				},
				"box2": {
					"title": "2,5 mal höheres Verkaufsvolumen*",
					"text": "Im letzten Jahr haben Klarna-Händler am Black Friday ein 2,5 mal höheres Verkaufsvolumen verzeichnen können als an jedem anderen Tag im Jahr.",
					"footnote": "*Durchschnitt aller Händlerkategorien und -regionen bei Klarna."
				},
				"sectionTitle": "Sorgen wir am Black Friday für mehr Umsatz",
				"marketing": {
					"title": "Vermarkten Sie Ihr Geschäft vor dem und am Black Friday",
					"text": "Locken Sie mit diesen kostenlos nutzbaren Ressourcen für Social Media- und E-Mail-Kampagnen in der Shopping-Saison um den Black Friday mehr Kunden in Ihr Geschäft."
				},
				"branding": {
					"title": "Stellen Sie sich in der Klarna App hervor",
					"text": "12 Millionen Kunden nutzen die Klarna App jeden Monat. Sorgen Sie dafür, dass Sie diesen Black Friday in der App hervorstechen, indem Sie Informationen zu Ihrer Marke hier im Händlerportal hinzufügen und aktualisieren."
				},
				"cta": "Los geht's",
				"close": "Schließen"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Bestellumsatz",
				"orderCountTitle": "Erstellte Bestellungen",
				"orderCount": "{count} Bestellungen",
				"box": {
					"title": "Möchten Sie Ihre Conversion-Rate noch weiter steigern?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Werbebotschaften, die bilden.",
					"text": "Unser On-site messaging-Tool hilft Ihnen, Ihre Verkäufe und durchschnittlichen Bestellwerte durch Werbebotschaften zu steigern. Informieren Sie Ihre Kunden, sobald sie auf Ihre Website kommen und während ihres gesamten Einkaufes über ihre Zahlungsoptionen.",
					"cta": "Los geht's"
				},
				"selector": {
					"done": "Fertig",
					"applySelection": "# Auswahl(en) anwenden",
					"selectAll": "Alle auswählen",
					"allOptions": "Alle Optionen ausgewählt",
					"someOptions": "# Optionen ausgewählt",
					"storeMultiSelectLabel": "# Shops auswählen",
					"allStores": "Alle Shops"
				},
				"currencyLabel": "Währung auswählen",
				"storeLabel": "Shop auswählen"
			},
			"v3": {
				"title": "Black-Friday-Woche",
				"text": "Dies sind Ihre Umsätze während einer der wichtigsten Verkaufswochen dieses Jahres.",
				"summaryTitle": "Zusammenfassung",
				"orderVolume": "Gesamtsumme",
				"orderCount": "Bestellungen insgesamt",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "im Vergleich zum gleichen Tag der Vorwoche",
				"tabs": {
					"monday": "Montag",
					"tuesday": "Dienstag",
					"wednesday": "Mittwoch",
					"thursday": "Donnerstag",
					"blackFriday": "Black Friday",
					"saturday": "Samstag",
					"sunday": "Sonntag",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};